export const unwrapOutfitsPayload = (data) => {
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.outfits)) return data.outfits;
  return [];
};
